import React, { FC, Fragment, useEffect, useState } from 'react'
import { Container, Hidden } from '@material-ui/core';
import { useHistory, useLocation } from 'react-router-dom';
import { RouteLocationProps, CheckoutLocationProps } from '../../routes/mobilbase';
import NavigationTabs from './NavigationTabs';
import BottomNav from './BottomNav';
import RouteHandler from './RouteHandler';

interface Nav {
  location: boolean;
  device: boolean;
  search: boolean;
  log: boolean;
  manage: boolean;
}

const InternalNavigation: FC = () => {
  const history = useHistory();
  const routeLocation = useLocation<RouteLocationProps>();
  const { page } = (routeLocation.state) ? routeLocation.state : new RouteLocationProps();
  const [currentPage, setCurrentPage] = useState(-1);
  const [currentNav, setCurrentNav] = useState<Nav>({ location: true, device: false, search: false, log: false, manage: false });

  useEffect(() => {
    if (currentPage === -1 || currentPage !== page) {
      const { page } = (routeLocation.state) ? routeLocation.state : new RouteLocationProps();
      setCurrentPage(page);
      setCurrentNav(getNav(page));
    }
  }, [currentPage, page, routeLocation.state]);

  const getNav = (page: number) => {
    let nav: Nav = { location: true, device: false, search: false, log: false, manage: false };
    switch (page) {
      case 0: //LOCATION
        nav = { location: true, device: false, search: false, log: false, manage: false }
        break;
      case 1: //DEVICE
        nav = { location: true, device: true, search: true, log: false, manage: false }
        break;
      case 2 || 5: //SEARCH
        nav = { location: true, device: true, search: true, log: false, manage: false }
        break;
      case 3: //LOG
        nav = { location: true, device: true, search: true, log: true, manage: true }
        break;
      case 4: //MANAGE
        nav = { location: true, device: true, search: true, log: true, manage: true }
        break;
      default:
        break;
    }
    return nav;
  };

  const changePage = (historyState: RouteLocationProps) => {
    setCurrentPage(historyState.page);
    setCurrentNav(getNav(historyState.page))

    switch (historyState.page) {
      case 0: //LOCATION
       history.push('/mobilbase/plads', historyState); break;
      case 1: //DeviceOverview
       history.push('/mobilbase/plads/automat', historyState); break;
      case 2: //SEARCH
       history.push('/mobilbase/plads/search', historyState); break;
      case 3: //DeviceLog
       history.push('/mobilbase/plads/automat/log', historyState); break;
      case 4: //DeviceManage
       history.push('/mobilbase/plads/automat/administrer', historyState); break;
      default: break;
    }
  };

  const changePageCheckout = (historyState: CheckoutLocationProps) => {
    setCurrentPage(2);
    setCurrentNav({ location: true, device: true, search: true, log: false, manage: false });
    history.push('/mobilbase/plads/automat/checkout', historyState);
  };

  const handleChange = (_: React.ChangeEvent<{}> | null, newValue: number) => {
    const { selectedLocationId, selectedLocationName, selectedDeviceId, selectedDeviceName } = (routeLocation.state) ? routeLocation.state : new RouteLocationProps();
    changePage(new RouteLocationProps(newValue, selectedLocationId, selectedLocationName, selectedDeviceId, selectedDeviceName));
  };

  return (
    <Fragment>
      <Hidden smDown>
        {/* <Container> Consider?*/}
          <NavigationTabs currentPage={currentPage} handleChange={handleChange} currentNav={currentNav} />
        {/* </Container> */}
      </Hidden>
      <RouteHandler changePage={changePage} changePageCheckout={changePageCheckout} />
      <Hidden mdUp>
        <BottomNav currentPage={currentPage} handleChange={handleChange} currentNav={currentNav} />
      </Hidden>
    </Fragment>
  );
};

export default InternalNavigation;